import React from "react";
import { AppBar, Toolbar, Box, useTheme } from "@mui/material";
import { LOGO_URL } from "../config/constants";

const Header = () => {
  const theme = useTheme();

  return (
    <AppBar position="static">
      <Toolbar>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            padding: theme.spacing(1),
          }}
        >
          <img
            src={LOGO_URL}
            alt="StreamingHD Logo"
            style={{
              height: 50,
              maxWidth: "100%",
            }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
